export default __webpack_public_path__ + "static/ways-to-earn-bg-tablet-7c559b9d485beb6662bd2e45da7eec8d.webp";